import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';

interface VendorOpsKpis {
  readonly pendingAcceptanceCount: number;
  readonly awaitingPainterAssignmentCount: number;
  readonly inExecutionCount: number;
  readonly completedTodayCount: number;
  readonly slaBreachCount: number;
  readonly avgAcceptanceMinutes: number;
  readonly performanceScore: number;
}

export function VendorOpsDashboardPage(): ReactNode {
  const { token } = useAuth();
  const [kpis, setKpis] = useState<VendorOpsKpis | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<VendorOpsKpis>('/v1/vendor/dashboard', { token })
      .then((r) => { if (alive) setKpis(r); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <main aria-label="vendor-ops-dashboard"><p role="alert">{error}</p></main>;
  if (!kpis) return <main aria-label="vendor-ops-dashboard"><p>Loading…</p></main>;

  return (
    <main aria-label="vendor-ops-dashboard">
      <h1>Vendor Operations Dashboard</h1>
      <ul aria-label="kpi-list">
        <li aria-label="kpi-pending-accept">Pending acceptance: {kpis.pendingAcceptanceCount}</li>
        <li aria-label="kpi-awaiting-painter">Awaiting painter: {kpis.awaitingPainterAssignmentCount}</li>
        <li aria-label="kpi-in-execution">In execution: {kpis.inExecutionCount}</li>
        <li aria-label="kpi-completed-today">Completed today: {kpis.completedTodayCount}</li>
        <li aria-label="kpi-sla-breach">SLA breach: {kpis.slaBreachCount}</li>
        <li aria-label="kpi-avg-accept">Avg acceptance (min): {kpis.avgAcceptanceMinutes.toFixed(1)}</li>
        <li aria-label="kpi-perf-score">Performance score: {kpis.performanceScore.toFixed(2)}</li>
      </ul>
    </main>
  );
}
